import React, { useContext, useState, PropsWithChildren, useEffect } from 'react';

export interface GeolocationContextValue {
  position?: GeolocationPosition;
}

const GeolocationContext = React.createContext<GeolocationContextValue>({});

export function GeolocationContextProvider(props: PropsWithChildren) {
  const [position, setPosition] = useState<GeolocationPosition>();

  useEffect(() => {
    const handleGeolocationPostionError = (error: GeolocationPositionError): void => {
      console.warn(
        `GeolocationContext::handleGeolocationPositionError::${error.code}::${error.message}`,
      );
    };

    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (pos) => {
          setPosition(pos);
        },
        handleGeolocationPostionError,
        {
          maximumAge: 900000,
          timeout: 30000,
        },
      );
    }
  }, []);

  const value = { position };

  return <GeolocationContext.Provider value={value}>{props.children}</GeolocationContext.Provider>;
}

export const useGeolocationContext = () => {
  const context = useContext(GeolocationContext);
  if (!context) {
    throw new Error('useGeolocationContext hook must be used within a GeolocationContextProvider');
  }

  return context;
};
